(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-edit-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
               const itiInstances = {};
              var adphoneInputField = document.querySelectorAll(".address_phone");
              adphoneInputField.forEach((e)=>{
                var contrcode = e.dataset.contrcode;
                const iti = window.intlTelInput(e, {
                    initialCountry: contrcode,
                    hiddenInput: () => ({ phone: "address[phone]" }),
                    geoIpLookup: callback => {
                      fetch("/browsing_context_suggestions.json")
                        .then(res => res.json())
                        .then(data => callback(data.detected_values.country.handle))
                        .catch(() => callback("us"));
                    },
                    strictMode: true,
                    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
                   
                });
              itiInstances[e.id] = iti;
              });
              

                 $(document).on("click",".update-btn",function(){
                  var current_button = $(this);
                  $(current_button).addClass('is-animating disabled');
                  var errormsg = 'This field is requried.';
                  var form_id = $(this).closest('form').attr('id');
                  required = ["address[first_name]","address[last_name]","address[address1]","address[city]","address[zip]"];
                  for (i = 0; i < required.length; i++) {
                  var phoneinput = $('#' + form_id + ' input[name="' + required[i] + '"]');
                  if (phoneinput.val() == '' || phoneinput.val() == errormsg) {
                      phoneinput.addClass('needsfilled');
                      phoneinput.val(errormsg);
                    } 
                 }
                 var errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
                 var cfomid = $(this).attr('data-form-id');
                 const iti = itiInstances["AddressPhone_" + cfomid];
                 var adphoneinput = document.getElementById("AddressPhone_"+cfomid);
                if (!adphoneinput.value.trim()) {
                  adphoneinput.classList.add('needsfilled');
                  adphoneinput.value = 'This field is requried.';
                } else if (iti.isValidNumber()) {
                  $('#'+form_id+' input[name="address[phone]"]').val(iti.getNumber());
                  adphoneinput.classList.remove('needsfilled');
                } else {
                  const errorCode = iti.getValidationError();
                  const msg = errorMap[errorCode] || "Invalid number";
                  adphoneinput.classList.add('needsfilled');
                  adphoneinput.value = msg;
                }
                  if ($(":input").hasClass("needsfilled")) { 
                    $(current_button).removeClass('is-animating disabled');
                    return false;
                  }
                  else {
                    $(this).closest('form').submit();
                    return true;
                  }
                });
        });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["announcement_banner"] && !Shopify.designMode) return;
  try {
    // Set Launch Date (ms)
  const launchDatenewone = new Date('Apr 02, 2026 23:59:59 UTC-07:00').getTime();

  // End Date
  const endDateone = new Date().getTime();

  // Context object
  const c1 = {
    context: {},
    values: {},
    times: {},
  };

  // Convert radians to degrees
  function deg(d) {
    return (Math.PI / -180) * d - (Math.PI / 180) * 90;
  }

  function render() {
    c1.context.seconds.clearRect(0, 0, 74, 74);
    c1.context.seconds.beginPath();
    c1.context.seconds.strokeStyle = '#000000';
    c1.context.seconds.arc(40, 40, 30, deg(0), deg(6 * (60 - c1.times.seconds)));
    c1.context.seconds.lineWidth = 3;
    c1.context.seconds.lineCap = 'round';
    c1.context.seconds.stroke();

    c1.context.minutes.clearRect(0, 0, 74, 74);
    c1.context.minutes.beginPath();
    c1.context.minutes.strokeStyle = '#000000';
    c1.context.minutes.arc(40, 40, 30, deg(0), deg(6 * (60 - c1.times.minutes)));
    c1.context.minutes.lineWidth = 3;
    c1.context.minutes.lineCap = 'round';
    c1.context.minutes.stroke();

    c1.context.hours.clearRect(0, 0, 74, 74);
    c1.context.hours.beginPath();
    c1.context.hours.strokeStyle = '#000000';
    c1.context.hours.arc(40, 40, 30, deg(0), deg(15 * (24 - c1.times.hours)));
    c1.context.hours.lineWidth = 3;
    c1.context.hours.lineCap = 'round';
    c1.context.hours.stroke();

    c1.context.days.clearRect(0, 0, 74, 74);
    c1.context.days.beginPath();
    c1.context.days.strokeStyle = '#000000';
    c1.context.days.arc(40, 40, 30, deg(0), deg(360 - c1.times.days));
    c1.context.days.lineWidth = 3;
    c1.context.days.lineCap = 'round';
    c1.context.days.stroke();
  }

  function init() {
    // Get 2D contexts
    c1.context.seconds = document.getElementById('seconds-canvas-promo').getContext('2d');
    c1.context.minutes = document.getElementById('minutes-canvas-promo').getContext('2d');
    c1.context.hours = document.getElementById('hours-canvas-promo').getContext('2d');
    c1.context.days = document.getElementById('days-canvas-promo').getContext('2d');

    // Get displayed values
    c1.values.seconds = document.getElementById('seconds-value-promo');
    c1.values.minutes = document.getElementById('minutes-value-promo');
    c1.values.hours = document.getElementById('hours-value-promo');
    c1.values.days = document.getElementById('days-value-promo');

    if (endDateone < launchDatenewone) {
      var x = setInterval(function () {
        // Get todays date and time (ms)
        const now = new Date().getTime();

        // Get distance from now to launchDate
        const distance = launchDatenewone - now;

        // Time calculations
        c1.times.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        c1.times.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        c1.times.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        c1.times.seconds = Math.floor((distance % (1000 * 60)) / 1000);

        c1.values.days.innerText = c1.times.days;
        c1.values.hours.innerText = c1.times.hours;
        c1.values.minutes.innerText = c1.times.minutes;
        c1.values.seconds.innerText = c1.times.seconds;

        if (distance < 0) {
          clearInterval(x);
          $('.countdown-canvas').addClass('time-expired');
        }

        render(); // Draw!
      }, 100);
    }
  }

  init();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-sidebar"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
          $('#opentab').click(function () {
              $('.article_wrapper').toggleClass('active');
              $('.article_content').slideToggle();
              $('#opentab').toggleClass('rotate-edge');
          });
          toggleTopButton();

      $('#scroll-top').on('click', function () {
          $('html, body').animate({ scrollTop: 0 }, 'slow');
      });

      $(window).on('scroll', function () {
          toggleTopButton();
      });

      function toggleTopButton() {
          if ($(window).scrollTop() === 0) {
              $('.top_scroll_wrapper').fadeOut();
          } else {
            if($(window).scrollTop() >= 750){
              $('.top_scroll_wrapper').fadeIn();
            }
          }
      }
      $('.article_content ul li a').on('click', function (e) {
          e.preventDefault();

          var $clickedLi = $(this).closest('li');
          var isInner = $clickedLi.closest('.inner_articleul').length > 0;

          $('.article_content li').removeClass('highlight');

          $clickedLi.addClass('highlight');

          // Scroll to the target
          var targetId = $(this).attr('href');
          var targetOffset = $(targetId).offset().top;
          var headerHeight = 90;

          $('html, body').animate({
              scrollTop: targetOffset - headerHeight
          }, 500);
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blognewsletter"] && !Shopify.designMode) return;
  try {
    $(document).ready(function(){
  //console.log('forms');
  $("form#blogsubscribeform").submit(function(){
    email = $("#email_coco-cloud");
    if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {
      email.addClass("needsfilled");email.val('Enter valid email address');}
    if ($(":input").hasClass("needsfilled")) {
      return false;
    }else {
      $('button#blogsubscribebutton').css("pointer-events", "none");
      var useremail =$("#email_coco-cloud").val();
      $.ajax({
        url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
        type: 'POST',
        data: {ajaxaction:"subscribelist",subemailaddress:useremail},
        async: true,
        success: function (response) {
          $("form#blogsubscribeform").get(0).reset()
          alert('Thanks for subscribe.');
          $('button#blogsubscribebutton').css("pointer-events", "auto");
        },
        timeout: 5000000, // sets timeout to 5 seconds
      });
      return false;
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    $('#stickycheckoutbutton').click(function(){
    $('#cartformsubmit').trigger('click');
  });

  if ($(".overview__holder").length > 0) {

      let target =   $('.overview__holder')
      // sticky bar
      $(window).on('scroll', function () {
          let targetTop =  target.offset().top
          let targetHeight =   target.innerHeight()

          let targetMass = targetTop + targetHeight
          let windowScrol = $(window).scrollTop()
          let windowScrolExtra = $(window).scrollTop() + $(window).height()

          if (windowScrolExtra > targetTop + (targetHeight/2) && windowScrol < targetMass ) {
              $("body").addClass('hide-block')
          } else {
              $("body").removeClass('hide-block')
          }
      });

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-editprofile"] && !Shopify.designMode) return;
  try {
    (function($){
      $(document).ready(function(){

        // Initialize intl-tel-input
         const phoneInputField = document.querySelector("#customer_phone");
         const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
         const iti = window.intlTelInput(phoneInputField, {
         initialCountry: "auto",
          hiddenInput: () => ({ phone: "customer_phone" }),
          geoIpLookup: callback => {
          fetch("/browsing_context_suggestions.json")
            .then(res => res.json())
            .then(data => callback(data.detected_values.country.handle))
            .catch(() => callback("us"));
         },
         strictMode: true,
         utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
        });

        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#customer_edit_profile").submit(function(){
          required = ["customer_first_name","customer_last_name"];
          email = $("#customer_email");
          for (i=0;i<required.length;i++) {
            var phoneinput = document.getElementById("customer_phone");
            if (!phoneinput.value.trim()) {
              phoneinput.classList.add('needsfilled');
              phoneinput.value = 'This field is requried.';
            } else if (iti.isValidNumber()) {
              phoneinput.classList.remove('needsfilled');
            } else {
              const errorCode = iti.getValidationError();
              const msg = errorMap[errorCode] || "Invalid number";
              phoneinput.classList.add('needsfilled');
              phoneinput.value = msg;
            }

            // if ((input.val() == "") || (input.val() == emptyerror)) {
            //   input.addClass("needsfilled");
            //   input.val(emptyerror);
            //   errornotice.fadeIn(750);
            // } else {
            //   input.removeClass("needsfilled");
            // }
          }
          var newpassword = $('#customer_password').val();
          var conformpassword = $('#customer_confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if($('#customer_password').val()!='' && $('#customer_password').val().length <8){$('#customer_password').addClass("needsfilled");$('#customer_password').val('should contain 8 characters').attr('type', 'text');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=conformpassword){
            $('#customer_password').addClass("needsfilled");
            $("#customer_confirm_password").val("Confirm Password not match with password");
            $('#customer_confirm_password').addClass("needsfilled");
            return false;

          }else {

            var $form = $('#customer_edit_profile');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#update_profile').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#update_profile').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/index.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#update_profile').prop('disabled', false);

                if(data=='Sucess'){
                  alert('Profile Update Sucessfully.');
                }else{
                  alert(data);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
        $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind("keypress", function (event) {
          var keyCode = event.which ? event.which : event.keyCode

          if ((keyCode == 43)) {
            return true;
          }else if (!(keyCode >= 48 && keyCode <= 57 )){
            return false;
          }

          var minLength = 15;
          var phone = $(this).val();
          if (phone.length > minLength){
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");$("#customer_password").attr('type', 'password');}});
    })(jQuery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["serum-bundle-option"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {

  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    async:false,
    success: function (cart) {
      $(".headerCartItems").html(Number(cart.item_count));
    }
  });
      function updateActiveState(selectedId) {
          //console.log('selectedId', selectedId)
          $('.bundlebox_bottlescontent').removeClass('active');
          var selctedoffer = '';

             if (selectedId === 6) {
                  selctedoffer = "43%";
                  freegiftshow = 4;
              } else if (selectedId === 4) {
                  selctedoffer = "40%";
                freegiftshow = 3;
              } else if (selectedId === 3) {
                  selctedoffer = "28%";
                freegiftshow = 2;
              } else {
                  selctedoffer = "13%";
                freegiftshow = 1;
              }

          $('#limited_offer').text(selctedoffer);

          let selectedBottle = $('.bundlebox_bottlescontent[data-id="' + selectedId + '"]');
          selectedBottle.addClass('active');
          selectedBottle.find('input[type="radio"]').prop('checked', true);

          $('.bundlebox_card').removeClass('is-active');
        let bundlebox_card = document.querySelectorAll(".bundlebox_card");
         for (let i = 0; i < freegiftshow; i++) {
                bundlebox_card[i].classList.add("is-active")
              }
          $('.common-btn-filled').attr('href',window.Shopify.routes.root+'pages/serum-starter-kit?quantity='+selectedId);
      }

    function getFullDate() {
  var monthNames = new Array("Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec.");
  var dayNames = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
  var now = new Date();
  now.setDate(now.getDate());
        var english_ordinal_suffix = (now.getDate() % 10 == 1 && now.getDate() != 11 ? 'st' :
            (now.getDate() % 10 == 2 && now.getDate() != 12 ? 'nd' :
            (now.getDate() % 10 == 3 && now.getDate() != 13 ? 'rd' : 'th')));
  var nowString =/* dayNames[now.getDay()] + ", " +*/ monthNames[now.getMonth()] + " " + now.getDate()+english_ordinal_suffix /*+ ", " + now.getFullYear()*/;
        var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = nowString;
        }
    }
      $('.bundlebox_bottlescontent').click(function () {
          var selectedId = parseInt($(this).attr('data-id'));
          updateActiveState(selectedId);
      });
    $('.select_scents_option').click(function(){
     var optionselected = document.querySelector('input[name="choosebottles"]:checked').value;

       dataLayer.push({ scents: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "select_scents",
            scents: parseInt(optionselected)
          });
    });
    if(window.Shopify.routes.root.includes('/es')){
  const escurrentDate = new Date(); // Gets the current date and time
  var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = escurrentDate.toLocaleDateString('es-ES', { month: 'long',  day: 'numeric' });
        }
}else{
  getFullDate();
}
  });
  } catch(e) { console.error(e); }
})();

})();
